import { render, staticRenderFns } from "./ddJump.vue?vue&type=template&id=ab575df4&scoped=true&"
import script from "./ddJump.vue?vue&type=script&lang=ts&"
export * from "./ddJump.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab575df4",
  null
  
)

export default component.exports